<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="align-left">
            <small class="text-muted">Expense Form</small>
        </h3>
        <div class="dropdown-divider"></div><br />
        <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
        <app-data-search v-on:searching="search"></app-data-search>
        <button type="button" class="btn btn-outline-primary" @click="add">Add  <i class="far fa-file"></i></button>
        <button type="button" class="btn btn-outline-info" @click="edit" style="margin-left: 20px;">Edit <i class="far fa-edit"></i></button>
        <!-- <button type="button" class="btn btn-outline-success" @click="preview">Preview <i class="fas fa-print"></i></button> -->
        <div style="float:right;">
            <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button>
        </div>
        <br /><br />
        <app-datatable :type="'view'" :elements="dtElements" :collections="expenseForm" v-on:selectedRow="selectRow"></app-datatable>
        <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ExpenseForm } from '../../models/expenseForm'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppNavBar
    },
    data() {
        return {
            expenseForm: [ExpenseForm],
            dtElements: [
                {
                    title: 'Expense No',
                    column: 'expensesFormNo',
                    type: 'text'
                },
                {
                    title: 'Expense Name',
                    column: 'expenseName',
                    type: 'text'
                },
                {
                    title: 'Expense Price',
                    column: 'price',
                    type: 'currency'
                },
                {
                    title: 'Remarks',
                    column: 'remarks',
                    type: 'text'
                },
                {
                    title: 'Updated At',
                    column: 'updatedAt',
                    type: 'date'
                },
            ],
            modalElements: {
                modalId: 'expenseForm',
                title: 'Confirm',
                content: 'Are you sure to delete this data?',
                type: 'text-confirm'
            },
            selectedId: '',
            searchKey: '',
            pagination: {
                pageSize: 10,
                currentPage: 1
            }
        }
    },
    async created() {
        this.init()
    },
    methods: {
        async init() {
            const efApi = api('expense-form/partial')
            const query = {
                params: {
                    searchKey: this.searchKey,
                    currentPage: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                }
            }
            this.expenseForm = await efApi.getWithQuery(query) 
        },
        add() {
            this.$router.push({ name: 'expenseFormDetail' })
        },
        edit() {
            if(this.selectedId !== '') {
                this.$router.push({
                    name: 'expenseFormDetail',
                    query: {
                        id: this.selectedId
                    }
                })
            }
        },
        async del() {
            if(this.selectedId !== '') {
                const efApi = api('expense-form/delete')
                await efApi.delete(this.selectedId)
                this.init()
            }
        },
        selectRow(id) {
            this.selectedId = id
        },
        changePage(payload) {
            this.pagination = payload
            this.init()
        },
        search(searchKey) {
            this.searchKey = searchKey
            this.init()
        }
    }
}
</script>